<template>
    <div class="fotter">
     <q-layout-footer >
   <q-tabs
        v-if="$route.name != 'Login'"
        class="footer"
        inverted
        :key="'other-secondary'"
        :color="'secondary'"
        align="justify"
      >
        <q-tab @click="go('Score')" slot="title" icon="" label="Score" />
        <q-tab @click="go('MyPage')" slot="title" icon="" label="MyPage" />
   </q-tabs>
   </q-layout-footer>
   </div>
</template>

<script>
export default {
  // TODO ダミーなので後で消す
  data () {
    return {
      path: 'aa'
    }
  },
  methods: {
    go (pathName) {
      this.$router.push({ name: pathName })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Footer.vue